<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.category' clearable
                                                      :placeholder="$t('分类') " style='width:120px'>

              <Option :key="key" :value="value"
                      v-for="(value, key) in extraParams"> {{ value }}
              </Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.fieldName' :placeholder="$t('玩法') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.title' :placeholder="$t('默认标题') "></Input>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button v-if="isCanEdit==1" type='primary' @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
            <p>请不要删除已有玩法,部分玩法没选择分类是首页使用的,不参与帖子生成的玩法,不要开启就行</p>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="768" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">

        <FormItem label='分类' prop='category'>
          <Select clearable v-model='windowAddItem.category' clearable
                  :placeholder="$t('分类') " style='width:120px'>

            <Option :key="key" :value="value"
                    v-for="(value, key) in extraParams"> {{ value }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label='玩法' prop='fieldName'>
          <Input clearable v-model='windowAddItem.fieldName' :placeholder="$t('请输入玩法名称')"></Input>
        </FormItem>


        <FormItem label='玩法默认标题' prop='title'>
          <Input clearable v-model='windowAddItem.title' :placeholder="$t('请输入玩法默认标题(多个可选标题)可用 | 隔开')"></Input>
        </FormItem>
<!--        <FormItem label='生成准确率(2~20)' prop='times'>-->
<!--          <Input clearable v-model='windowAddItem.times' :placeholder="$t('填越高,生成准确率越高(2~20) 注:不是百分比,指的是随机循环几次')"></Input>-->
<!--        </FormItem>-->
        <FormItem label='生成期数' prop='autoMakeNums'>
          <Input clearable v-model='windowAddItem.autoMakeNums' :placeholder="$t('生成期数')"></Input>
        </FormItem>
        <FormItem label='错误期数(最大值)' prop='autoMakeErrorMax'>
          <Input clearable v-model='windowAddItem.autoMakeErrorMax' :placeholder="$t('错误期数(最大值)')"></Input>
        </FormItem>
        <FormItem label='错误期数(最小值)' prop='autoMakeErrorMin'>
          <Input clearable v-model='windowAddItem.autoMakeErrorMin' :placeholder="$t('错误期数(最小值)')"></Input>
        </FormItem>
        <FormItem label='错误位置' prop='errorPosition'>
          <Input clearable v-model='windowAddItem.errorPosition' :placeholder="$t('逗号隔开(如：1,2,3)不能少于错误期数最大值,不填则随机位置')"></Input>
        </FormItem>

        <FormItem label='玩法权重(1~10)' prop='playWeight'>
          <Input clearable v-model='windowAddItem.playWeight' :placeholder="$t('玩法权重(1~10),越大生成优先级越高')"></Input>
        </FormItem>

        <FormItem v-if="isCanEdit==1" label='开奖匹配类型(参考已有玩法填写多个玩法使用|连接)' prop='matchType'>
          <Input clearable v-model='windowAddItem.matchType' :placeholder="$t('开奖匹配类型,使用 | 连接,请参与已有的玩法仿写')"></Input>
        </FormItem>

        <FormItem label='玩法备注' prop='remark'>
          <Input clearable v-model='windowAddItem.remark' :placeholder="$t('玩法备注')"></Input>
        </FormItem>



        <FormItem v-if="isCanEdit==1" label='生成方式' prop='generate'>
          <Input clearable v-model='windowAddItem.generate' :placeholder="$t('请输入生成方式')"></Input>
          <span> (1~10生成几个数字码)<br>
 (one-ten是生成几个生肖)<br>
  (ds 生成单双)<br>
(onecolor生成一个波色 \  twocolor生成两个波色  )<br>
(home_1~home_9 生成几只家禽 beast_1~beast_4 是几只野兽)<br>
(tail_0~tail_9 是几个尾数)<br>
 (jy 生成家禽或野兽)<br>
| 符号是多个选项时使用 如: 女肖|男肖<br>
+ 是多合一时使用的 如  二肖+二码可以用 two+2<br>
 * 是多次生多个时使用  如:二行 可以用  金|木|水|火|土*2<br>
- 是主时使用的 如  二肖主二码可以用 two-2<br>
</span>
        </FormItem>
        <FormItem v-if="isCanEdit==1" label='内容是否杀肖' prop='isIn'>
          <Select clearable v-model='windowAddItem.isIn' style='width:200px'>
            <Option :value="'1'" :key='1'>{{ $t('否') }}</Option>
            <Option :value="'0'" :key='0'>{{ $t('是') }}</Option>
          </Select>
        </FormItem>


<!--        <FormItem label='是否尾数' prop='isWs'>-->
<!--          <Select clearable v-model='windowAddItem.isWs' style='width:200px'>-->
<!--            <Option :value="'0'" :key='0'>{{ $t('否') }}</Option>-->
<!--            <Option :value="'1'" :key='1'>{{ $t('是') }}</Option>-->
<!--          </Select>-->
<!--        </FormItem>-->
        <FormItem v-if="isCanEdit==1" label='是否包含小码(平特\复式需要选是)' prop='isAllNum'>
          <Select clearable v-model='windowAddItem.isAllNum' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('否') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('是') }}</Option>
          </Select>
        </FormItem>

        <FormItem v-if="isCanEdit==1" style="margin-bottom:4px" label='玩法模板(建议复制之前写好的来改样式就可以了)' prop='body'>
          <span v-pre> {{$value['issue']}} 期号<br>
{{$author}}作者<br>
{{$title}}标题<br>
{{$value['code']}}内容<br>
            {!!$value['colorCode']!!}内容带颜色<br>
{{$value['open']}}开奖结果 如:鼠01<br>
{{$value['opened']}}开奖内容 如: 金 <br>
{{$value['isZhun']}}是否准<br>
            {!!$value['zhongNum']!!}中奖个数<br>
             {!!$value['smallTip']!!}提示<br>
            特殊写法(可以使用简单的PHP代码对结果进行排版)<br>
            {{mb_substr($value['code'], 0, 4)}}前4个生肖(内容是生肖)<br>
{{mb_substr($value['code'], -4)}} 后4个生肖(内容是生肖)<br>
            {{implode('.', array_slice(explode('.', $value['code']), 0, 4))}} 前4个号码(内容是号码);<br>
             {{implode('.', array_slice(explode('.', $value['code']), -4))}} 后4个号码(内容是号码);<br>
例子:1:{{$value['issue']}}期:{{$author}}★{{$title}}〖{!!$value['colorCode']!!}〗开:{!!$value['tip']!!}{{$value['isZhun']}} {!!$value['smallTip']!!}
            2:  {{$value['issue']}}期:{{$author}}★{{$title}}〖{!!$value['colorCode']!!}〗开:{!!$value['zhongNum']!!}个{{$value['isZhun']}} {!!$value['smallTip']!!}<br>
</span>
<!--          <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{-->
<!--              $t('编辑源码')-->
<!--            }}-->
<!--          </Button>-->

<!--          <div v-if="isHtml==false" style="border: 1px solid #ccc;">-->
<!--            <Toolbar-->
<!--              style="border-bottom: 1px solid #ccc"-->
<!--              :editor="editor"-->
<!--              :defaultConfig="toolbarConfig"-->
<!--              :mode="mode"-->
<!--            />-->
<!--            <Editor-->
<!--              style="height: 200px; overflow-y: hidden;"-->
<!--              v-model="windowAddItem.template"-->
<!--              :defaultConfig="editorConfig"-->
<!--              :mode="mode"-->
<!--              @onCreated="onCreated"-->
<!--            />-->
<!--          </div>-->
          <textarea  v-model="windowAddItem.template" name="ckeditor" rows="10" cols="88"></textarea>
          <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>

        <FormItem style="margin-bottom:4px" label='玩法说明(有些玩法要写说明,可以在这里写)' prop='body'>
          <Button type="text" @click="isHtml2=!isHtml2" class="margin-left-10">{{
              $t('编辑源码')
            }}
          </Button>

          <div v-if="isHtml2==false" style="border: 1px solid #ccc;">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor2"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 200px; overflow-y: hidden;"
              v-model="windowAddItem.tip"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated2"
            />
          </div>
          <textarea v-if="isHtml2==true" v-model="windowAddItem.tip" name="ckeditor2" rows="10" cols="88"></textarea>
          <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

import CKEDITOR from 'CKEDITOR'
import {baseUrl} from '@/libs/api.request'
import {getToken,
  localSave,
  localRead} from '@/libs/util'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

export default {
  name: 'interface_list',
  components: {Editor, Toolbar},
  data() {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {'Api-Auth': getToken()},

      editor: null,
      editor2: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple',
      isHtml: false,
      isHtml2: false,

      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('ID'),
        key: 'id',
        minWidth: 120,
        sortable: true,
        align: 'center'
      },{
        title: this.$t('分类'),
        key: 'category',
        minWidth: 120,
        sortable: true,
        align: 'center'
      },{
        title: this.$t('玩法'),
        key: 'fieldName',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('默认标题'),
        key: 'title',

        minWidth: 120,
        align: 'center'
      },{
        title: '玩法启用',
        sortable: true,
        align: 'center',
        width: 130,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isOpen,
            },
            on: {
              'on-change': function (status) {
                let vm = this
                customPost('Lhc/fieldUpdateOrCreate',{id:params.row.id,isOpen:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "启用"),
            h('span', {
              slot: 'close'
            }, "禁用")
          ])
        }
      },{
        title: this.$t('权重'),
        key: 'playWeight',
        sortable: true,
        minWidth: 67,
        align: 'center'
      },{
        title: this.$t('自动生成期数'),
        key: 'autoMakeNums',
        minWidth: 60,
        align: 'center'
      },{
        title: this.$t('最小错几期'),
        key: 'autoMakeErrorMin',
        minWidth: 60,
        align: 'center'
      },{
        title: this.$t('最多错几期'),
        key: 'autoMakeErrorMax',
        minWidth: 60,
        align: 'center'
      },{
        title: this.$t('备注'),
        key: 'remark',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem['id'] = params.row.id;
                vm.windowAddItem['fieldName'] = params.row.fieldName;
                vm.windowAddItem['category'] = params.row.category;
                vm.windowAddItem['generate'] = params.row.generate;
                vm.windowAddItem['isIn'] = params.row.isIn.toString();
                vm.windowAddItem['isWs'] = params.row.isWs.toString();
                vm.windowAddItem['isAllNum'] = params.row.isAllNum.toString();
                vm.windowAddItem['title'] = params.row.title;
                vm.windowAddItem['times'] = params.row.times;
                vm.windowAddItem['template'] = params.row.template;
                if( vm.isCanEdit==1){
                  this.editorObj1.setData(params.row.template)
                }

                vm.windowAddItem['tip'] = params.row.tip;

                vm.windowAddItem['autoMakeNums'] = params.row.autoMakeNums;
                vm.windowAddItem['autoMakeErrorMax'] = params.row.autoMakeErrorMax;
                vm.windowAddItem['autoMakeErrorMin'] = params.row.autoMakeErrorMin;
                vm.windowAddItem['playWeight'] = params.row.playWeight;
                vm.windowAddItem['remark'] = params.row.remark;
                vm.windowAddItem['matchType'] = params.row.matchType;

                vm.windowAddItem['errorPosition'] = params.row.errorPosition;

                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑玩法')),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      isCanEdit:0,
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created() {
    let vm = this
    if(this.$route.query['a']=='1'){
      console.log(this.$route.query['a'])
      this.isCanEdit=1;
    }
    vm.getList()
    vm.hasRule('LhcManage/LhcFielldBbs/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcFielldBbs/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcFielldBbs/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor != null) editor.destroy()
    // 组件销毁时，及时销毁编辑器
    const editor2 = this.editor2
    if (editor2 != null) editor2.destroy()
    // 组件销毁时，及时销毁编辑器
  },

  mounted() {
    this.getParams()
    this.initializeEditor()
  },
  methods: {
    initializeEditor () {
      this.editorObj1 = CKEDITOR.replace('ckeditor', {
        language: 'zh-CN',      // Adding drag and drop image upload.
        removeDialogTabs: 'image:advanced;image:Link',
        image_previewText: '  ',
        extraPlugins: 'uploadimage',
        uploadUrl: this.uploadUrlCk,
        filebrowserImageUploadUrl: this.uploadUrlCk,
        filebrowserUploadUrl: this.uploadUrlCk, //服务器上传地址
        removeButtons: 'Save,PasteFromWord,PasteText,Paste,Copy,Replace,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BulletedList,NumberedList,Indent,Outdent,Language,About,ShowBlocks,Flash,Anchor,HorizontalRule,PageBreak,Iframe'
      })

      // 图片上传返回的数据处理
      this.editorObj1.on('fileUploadResponse', function (evt) {
        evt.stop()
        var data = evt.data
        let xhr = data.fileLoader.xhr
        let response = xhr.responseText
        let imgUrl = JSON.parse(response).data.fileUrl
        if (!imgUrl) {
          data.message = '上传出错'   // 这是失败alert提示信息
          evt.cancel()
        } else {
          data.url = imgUrl   // 返回到“图像信息”那里的URL框里面
        }
      })

      //需要手动设置绑定
      // this.extraParams['ad1']=this.editorObj1.getData()
      //this.editorObj1.setData(this.extraParams['ad1'])
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreated2(editor2) {
      this.editor2 = Object.seal(editor2) // 一定要用 Object.seal() ，否则会报错
    },
    preAdd() {
      let vm = this
      vm.windowAddItem['id'] = 0;
      vm.windowAddItem['fieldName'] = '';
      vm.windowAddItem['category'] = '';
      vm.windowAddItem['generate'] = '';
      vm.windowAddItem['isIn'] = '1';
      vm.windowAddItem['isWs'] = '0';
      vm.windowAddItem['isAllNum'] = '0';
      vm.windowAddItem['title'] = '';
      if( vm.isCanEdit==1){
      this.editorObj1.setData('');
      }
      vm.windowAddItem['times'] = '2';
      vm.windowAddItem['template'] = '';
      vm.windowAddItem['tip'] = '';
      vm.windowAddItem['errorPosition'] = '';


      vm.windowAdd.show = true
    },
    getParams() {
      customPost('Lhc/fieldGetAllCategory',{}).then(response => {
          this.extraParams = response.data.data
      })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize

      customPost('Lhc/fieldGetList',vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          if( vm.isCanEdit==1) {
            vm.windowAddItem.template = this.editorObj1.getData();
          }
          customPost('Lhc/fieldUpdateOrCreate',vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
